import * as React from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import DashboardLayout from '../../../shared/LayoutContainers/DashboardLayout'
import DashboardNavbar from '../../../shared/Navbars/DashboardNavbar'
import TitleScreenCrud from '../../../shared/TitleScreenCrud'
import MDBox from '../../../shared/MDBox'
import MDTypography from '../../../shared/MDTypography'
import { Button } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import professorService from '../../professorService'
import { IProfessor, IAnamneseAluno } from '../../ProfessorType'
import { AnamneseGrid, AnamneseCard } from '../ListScreen/ProfessoresForm.styled'

export default function DetalheScreen() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')

  const [professor, setProfessor] = React.useState<IProfessor | null>(null)
  const [anamneses, setAnamneses] = React.useState<IAnamneseAluno[]>([])

  React.useEffect(() => {
    if (id) {
      professorService.getById(id).then(result => {
        if (result.data.length > 0) setProfessor(result.data[0])
      })
    }
  }, [id])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <TitleScreenCrud title={'Anamneses — ' + (professor?.nome || 'Professor')}>
        <MDBox padding={3}>
          <MDBox display="flex" gap={2} mb={3}>
            <Button
              startIcon={<ArrowBackIcon />}
              variant="outlined"
              style={{ borderRadius: 8, height: 40 }}
              onClick={() => navigate('/professores')}
            >
              Voltar
            </Button>
          </MDBox>

          {professor && (
            <MDBox mb={3}>
              <MDTypography variant="button" fontWeight="medium">
                {professor.nome} | {professor.cpf} | {professor.email}
              </MDTypography>
              <MDTypography variant="caption" color="text" style={{ display: 'block', marginTop: 4 }}>
                Especialidades: {typeof professor.especialidades === 'string' ? professor.especialidades : (professor.especialidades || []).join(', ')}
              </MDTypography>
            </MDBox>
          )}

          <MDTypography variant="h6" mb={2}>
            Anamneses dos Alunos Vinculados
          </MDTypography>

          {anamneses.length > 0 ? (
            <AnamneseGrid>
              {anamneses.map(anamnese => (
                <AnamneseCard key={anamnese.id}>
                  <MDTypography variant="button" fontWeight="medium">
                    {anamnese.alunoNome}
                  </MDTypography>
                  <MDTypography variant="caption" color="text" style={{ display: 'block', marginTop: 4 }}>
                    Data: {new Date(anamnese.dataCadastro).toLocaleDateString('pt-BR')}
                  </MDTypography>
                  <MDTypography variant="caption" color="text" style={{ display: 'block' }}>
                    Peso: {anamnese.peso} kg | Estatura: {anamnese.estatura} m
                  </MDTypography>
                  <MDTypography variant="caption" color="text" style={{ display: 'block', marginTop: 4 }}>
                    Objetivos: {anamnese.objetivos}
                  </MDTypography>
                </AnamneseCard>
              ))}
            </AnamneseGrid>
          ) : (
            <MDBox padding={3} textAlign="center">
              <MDTypography variant="button" color="text">
                Nenhuma anamnese encontrada para os alunos deste professor.
              </MDTypography>
            </MDBox>
          )}
        </MDBox>
      </TitleScreenCrud>
    </DashboardLayout>
  )
}
